export class AltaPayUtils {

    redirect(url){
        if (window.top === window.self) {
            window.location.href = url;
        } else {
            window.top.location.href = url;
        }
    }
}